import { Link } from 'gatsby'
import React from 'react'
import classNames from 'classnames'
import { BannerProps } from './Banner.d'

const Banner = ({ disabled, title, ctas }: BannerProps) => {
  return (
    !disabled && (
      <div className='mx-auto px-5 w-full relative font-sansPro'>
        <div className='max-w-7xl mx-auto relative'>
          <div className='flex py-5 w-full justify-center mx-auto text-otl-gray-dark text-lg'>
            <span className='font-bold inline-block'>{title}:</span>
            {ctas.map((cta, i) => {
              const linkClass = classNames(
                'overflow-hidden inline-block px-6',
                {
                  'border-r-otl-gray-light border-solid border-r':
                    i < ctas.length - 1
                }
              )
              return (
                <Link className={linkClass} key={i} to={cta.link}>
                  {cta.text}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    )
  )
}

export default Banner
